export default {
  root: {
    minHeight: 30,
    paddingLeft: 5,
    paddingRight: 5,
  },
};
